import { render } from "./SliderButton.vue?vue&type=template&id=166ca974"
import script from "./SliderButton.vue?vue&type=script&lang=js"
export * from "./SliderButton.vue?vue&type=script&lang=js"

import "./SliderButton.vue?vue&type=style&index=0&id=166ca974&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__